import { ChangeEvent, Dispatch, SetStateAction } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ServiceData } from "../ScheduleSelection-Tab-Services.component";
import { ServiceDataTableRows } from "./ScheduleSelection-Tab-Services-DataTableRow.partial";
import { NoPlaceZoneBooking } from "../../../../../features/Booking-Form/typings/booking-service-administration.types";
import { MaxSetUpTime } from "../../../../../features/Booking-Form/typings/booking-services.types";

type P = {
  isEditable: boolean;
  isColleagueScheduleEditable: boolean;
  cateringData: ServiceData[];
  setCateringData: Dispatch<SetStateAction<ServiceData[]>>;
  schedule: NoPlaceZoneBooking;
  remoteMaxSetupTime: MaxSetUpTime | undefined;
};

export function ServiceCateringDataTable({
  isEditable,
  isColleagueScheduleEditable,
  cateringData,
  setCateringData,
  schedule,
  remoteMaxSetupTime
}: Readonly<P>) {
  const { t } = useTranslation();

  function handleChangeQty(
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    item: ServiceData
  ) {
    const val = e.target.value;
    item.orderedQty = Number(val);
    const remained = cateringData.filter(data => data.id !== item.id);
    setCateringData([...remained, item]);
  }

  /* istanbul ignore next */
  function handleSelectOrder(item: ServiceData) {
    setCateringData(prev => [
      ...prev.filter(data => data.id !== item.id),
      item // updated one
    ]);
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell component="th">{}</TableCell>

            <TableCell component="th">{t("Name")}</TableCell>
            <TableCell component="th">{t("Image")}</TableCell>
            <TableCell component="th" align="left">
              {t("Status")}
            </TableCell>
            <TableCell component="th" align="left">
              {t("Delivery Qty")}
            </TableCell>
            <TableCell component="th" align="left">
              {t("Ordered Qty")}
            </TableCell>
            <TableCell component="th" align="left">
              {t("Available Qty")}
            </TableCell>
            <TableCell component="th" align="right" />
          </TableRow>
        </TableHead>

        <TableBody>
          <ServiceDataTableRows
            rowData={cateringData}
            handleChangeQty={handleChangeQty}
            handleSelectOrder={handleSelectOrder}
            isEditable={isEditable}
            isColleagueScheduleEditable={isColleagueScheduleEditable}
            schedule={schedule}
            maxSetupTime={remoteMaxSetupTime}
            showQty
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
}
